import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components/macro';
import { Typography } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';
import api from 'api';
import Loader from 'components/Loader/Loader';
import generateReportData from '../reportGenerator';
import Report from '../Report';

const ReportWrapper = styled.div`
  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 2.5rem;
  margin-top: -3rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.quillGray};
`;

const Email = styled(Typography)`
  color: ${({ theme }) => theme.colors.blue};
`;

interface Props {
  reportId: number;
  surveyUuid: string;
  organization: string;
  email: string | null;
}

const SingleReport = ({ reportId, surveyUuid, organization, email }: Props) => {
  const [report, setReport] = useState([]);
  const [isLoadinReport, setIsLoadingReport] = useState(true);
  const { locale } = useIntl();
  const t = useFormatMessage();

  const dataToSet = generateReportData(report, locale as any);

  useEffect(() => {
    api.resources
      .getSingleReport({
        organizationCodename: organization,
        surveyUuid,
        reportId,
      })
      .then(({ data }) => {
        setReport(data);
        setIsLoadingReport(false);
      });
    // eslint-disable-next-line
  }, [reportId]);
  return (
    <ReportWrapper>
      <TitleWrapper>
        <Typography variant="h6">
          {t(
            'customerSatisfaction.individualReport.title',
            'Individual answers'
          )}
        </Typography>
        {isLoadinReport ? <Loader /> : <Email variant="copy2">{email}</Email>}
      </TitleWrapper>
      <Report reportData={dataToSet} isSingleReport />{' '}
    </ReportWrapper>
  );
};

export default SingleReport;
